import { useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import { alpha } from "@mui/system";

const CollectionTableComponent = ({
  apiRef,
  rows,
  columns,
  handleColumnResize,
  visibilityModel,
  handleVisibilityChange,
  getRowId,
  getRowClassName,
  onRowClick
}) => {
  const theme = useTheme();

  return (
    <DataGrid
      apiRef={apiRef}
      disableColumnMenu={false}
      rows={rows}
      columns={columns}
      pageSize={5}
      sx={{
        border: "none",
        overflow: "hidden",
        width: "100%",
        "& .MuiDataGrid-cell:focus-within": {
          backgroundColor: "transparent",
          outline: "none",
        },
        "& .MuiDataGrid-row.Mui-selected": {
          backgroundColor: theme.palette.secondary.main,
          color: theme.palette.text.primary,
        },
        "& .MuiDataGrid-row.Mui-selected:hover": {
          backgroundColor: theme.palette.secondary.main,
          color: theme.palette.text.primary,
        },
        "& .MuiDataGrid-row:hover": {
          backgroundColor: theme.palette.secondary.main,
          color: theme.palette.text.primary,
        },
        "& .MuiDataGrid-row.sooth-misinformation-row": {
          backgroundColor: alpha(theme.palette.warning.light, 0.25),
        },
      }}
      onColumnWidthChange={handleColumnResize}
      columnVisibilityModel={visibilityModel}
      onColumnVisibilityModelChange={handleVisibilityChange}
      getRowId={getRowId}
      getRowClassName={getRowClassName}
      initialState={{
        sorting: {
          sortModel: [{ field: "createdDateTime_dtm", sort: "desc" }],
        },
      }}
      onRowClick={onRowClick}
    />
  );
};

export default CollectionTableComponent;